/* -----------------Globals--------------- */
import { useEffect } from "react";

/* -----------------Child components--------------- */
import StudySessionView from "../components/StudySessionView";

import { useAuthContext } from "@memorang/applets";
import { isUuid } from "@memorang/helpers";
import { useLocalSearchParams, useRouter } from "expo-router";
/* -----------------Helpers & Hooks--------------- */
import useSessionStore from "../hooks/useSessionStore";

/* -----------------UI--------------- */
import { Loader } from "@memorang/ui";

import MoreItemsAlertDialog from "../components/dialogs/MoreItemsAlertDialog";
/* -----------------Types--------------- */
import { useResumeSession } from "../hooks/useResumeSession";

const SessionContainer = () => {
	const sessionItems = useSessionStore((state) => state.sessionItems);
	const numItemsRequested = useSessionStore((state) => state.numItemsRequested);
	const sessionId = useSessionStore((state) => state.id);
	const showMoreItemsAlert = useSessionStore(
		(state) => state.showMoreItemsAlert,
	);

	const toggleShowMoreItemsAlert = useSessionStore(
		(state) => state.toggleShowMoreItemsAlert,
	);
	const { handleResumeSession } = useResumeSession();
	const { viewerId } = useAuthContext();
	const router = useRouter();

	const id = useLocalSearchParams<{
		id: string;
	}>().id;

	useEffect(() => {
		if (!sessionId && viewerId && id) {
			const sessionNumericId = isUuid(id) ? undefined : Number(id);
			if (sessionNumericId) {
				handleResumeSession(sessionNumericId).then((status) => {
					if (status === "failed") {
						router.replace("/home");
					}
				});
			} else {
				//formattive session, redirect to home since resume session is not supported
				router.replace("/home");
			}
		}
	}, [handleResumeSession, id, router, sessionId, viewerId]);

	if (!sessionId) {
		return <Loader />;
	}

	return (
		<>
			<StudySessionView sessionItems={sessionItems} />
			{showMoreItemsAlert && (
				<MoreItemsAlertDialog
					visible={showMoreItemsAlert}
					handleClose={toggleShowMoreItemsAlert}
					numItemsAvailable={sessionItems.length}
					numItemsRequested={numItemsRequested}
				/>
			)}
			{/* <AudioPlaybackTestDialog
				showDialog={showAudioPlaybackTestDialog}
				handleClose={() => {
					setShowAudioPlaybackTestDialog(false);
				}}
			/> */}
		</>
	);
};

export default SessionContainer;
